export default interface AccessToken {
  token: string
  type?: string | null
  expiresIn: number
}

export function isAccessToken(value: unknown): value is AccessToken {
  return (
    typeof value === 'object' &&
    value !== null &&
    typeof (value as Record<string, unknown>).token === 'string' &&
    typeof (value as Record<string, unknown>).expiresIn === 'number'
  )
}
